export const createGoldOtcLink = () => {
  return "/dashboard/GOLD18-IRT/buy";
};

export const createDashboardLink = () => {
  return "/dashboard";
};
